  
export default {
  primary: "#0081a7",
  inverse: "#fff",
  background:"fdfcdc",
  // colors
  darkGrey: "#333447",
  black: "#000",

  // grid
  width: "96%",
  wrapperWidth: "65rem",
  gutter: "4%",
  breakpointPhone: "850px",
  breakpointTablet: "1024px",
  breakpointLaptop: "1200px",
  breakpointLarge: "60em" // 960px
}